export enum MessageTypes {
  ok = "ok",
  error = "error",
  warning = "warning",
}
